export const STORAGE_KEYS = {
	EXAMPLE_STORAGE: 'exampleStorage',
	AUTH_STORAGE: 'authStorage',
	APP_SETTINGS_STORAGE: 'appSettings',
	SERVER_TIME_STORAGE: 'serverTime'
} as const;
